<template>
  <div v-if="value.source && value.type">
    <header class="flex items-center mb-6">
      <lm-icon :icon="value.type.toLowerCase()" class="mr-3 text-gray-700" />
      <h1 class="text-gray-700">{{ FeedSourcesLabels[value.type] }}</h1>
    </header>
    <lm-input
      ref="inputTitle"
      label="Title"
      focus
      @submit="$emit(Events.NEXT_STEP)"
    />
    <lm-textarea
      ref="inputDescription"
      label="Description (optional)"
      :rows="2"
      :allow-breakline="false"
      @submit="$emit(Events.NEXT_STEP)"
    />
    <lm-tags-selector
      ref="tagSelector"
      class="mb-16"
      :options="currentLandscape.tags"
      :required="requiredTagsFeedSource"
    />
  </div>
</template>

<script>
import FormHelper from '@/components/form/formHelper'
import LmInput from '@/components/form/LmInput'
import LmTagsSelector from '@/components/form/LmTagsSelector'
import LmTextarea from '@/components/form/LmTextarea'
import LmIcon from '@/components/ui/LmIcon'
import {Events, FeedSourcesLabels} from '@/lib/definitions'
import {mapGetters} from 'vuex'

export default {
  name: 'FeedSourceStep3',
  components: {LmTagsSelector, LmTextarea, LmInput, LmIcon},
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      Events,
      FeedSourcesLabels
    }
  },
  computed: {
    ...mapGetters(['currentLandscape']),
    ...mapGetters({
      requiredTagsFeedSource: 'preferences/requiredTagsFeedSource'
    })
  },
  watch: {
    value(v) {
      if (v && v.source && v.type) {
        this.$nextTick(() => {
          this.$refs.inputTitle.setData(v.title)
          this.$refs.inputDescription.setData(v.description)
        })
      }
    }
  },
  methods: {
    async init() {
      const input = this.$refs.inputTitle
      await this.$nextTick()
      input.setFocus()
    },
    validate() {
      return new Promise((resolve, reject) => {
        const r = FormHelper.validate([
          this.$refs.inputTitle,
          this.$refs.inputDescription,
          this.$refs.tagSelector
        ])
        if (r) {
          this.$emit('input', {
            ...this.value,
            title: this.$refs.inputTitle.data,
            description: this.$refs.inputDescription.data,
            tags: this.$refs.tagSelector.data
          })
          resolve()
        } else reject()
      })
    },
    clear() {
      this.$refs.inputTitle.reset()
      this.$refs.inputDescription.reset()
    }
  }
}
</script>

<style scoped></style>
